import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="max-w-4xl mx-auto px-4 py-10 space-y-6">
        <div className="space-y-2">
          <h1 className="text-3xl font-bold tracking-tight">Termos de Uso por Escrituração</h1>
          <p className="text-muted-foreground">
            Esta é a versão interna dos termos de uso por escrituração. Revise atentamente antes de continuar.
          </p>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>1. Objetivo</CardTitle>
          </CardHeader>
          <CardContent className="space-y-3 text-sm leading-relaxed">
            <p>
              O presente termo define as condições de uso do módulo de escrituração do Librattum, incluindo obrigações de
              guarda, integridade e consentimento do usuário.
            </p>
            <p>
              Ao continuar, você confirma que leu e concorda com as regras aplicáveis à coleta, armazenamento e exibição
              das informações financeiras registradas na plataforma.
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>2. Responsabilidades do Usuário</CardTitle>
          </CardHeader>
          <CardContent className="space-y-2 text-sm leading-relaxed">
            <p>• Garantir a veracidade das informações lançadas.</p>
            <p>• Manter credenciais de acesso sob sigilo.</p>
            <p>• Respeitar a legislação vigente para registros contábeis e fiscais.</p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>3. Tratamento de Dados</CardTitle>
          </CardHeader>
          <CardContent className="space-y-2 text-sm leading-relaxed">
            <p>
              Os dados inseridos são utilizados exclusivamente para a prestação dos serviços da plataforma, observando a
              legislação de proteção de dados aplicável. Consulte também a Política de Privacidade interna.
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>4. Suporte e Contato</CardTitle>
          </CardHeader>
          <CardContent className="space-y-2 text-sm leading-relaxed">
            <p>
              Em caso de dúvidas ou solicitações relacionadas aos termos de uso por escrituração, entre em contato com o
              suporte pelo menu “Suporte” dentro do aplicativo.
            </p>
          </CardContent>
        </Card>

        <Separator />
        <p className="text-xs text-muted-foreground">
          Última atualização: 05/12/2025 — Este conteúdo é exibido localmente para garantir que o link seja carregado
          corretamente.
        </p>
      </div>
    </div>
  );
};

export default TermsPage;
















